// import React from 'react';
// import '../loader.css';


// const Loading=({labelShow,label})=> {
    

//         return (  <div className="background-overlay ">
//         <div className="box">
//             <div className="loader-18"> {labelShow?<p style={{fontSize:25,marginLeft:13,paddingTop:18}}>{label}</p>:''}</div>
//         </div>  
       
//     </div> );
//     }

 
// export default Loading;

import React from 'react';
import '../loader.css';

const Loading = ({ labelShow, label }) => {
    return (
        <div className="background-overlay">
            <div className="box">
                <div className="boxes">
                    <div className="box">
                        <div></div>
                        <div></div>
                        <div style={{ border: 'none' }}></div>
                        <div></div>
                    </div>
                    <div className="box">
                        <div style={{ border: 'none' }}></div>
                        <div></div>
                        <div style={{ border: 'none' }}></div>
                        <div></div>
                    </div>
                    <div className="box">
                        <div style={{ border: 'none' }}></div>
                        <div></div>
                        <div style={{ border: 'none' }}></div>
                        <div></div>
                    </div>
                    <div className="box">
                        <div style={{ border: 'none' }}></div>
                        <div></div>
                        <div style={{ border: 'none' }}></div>
                        <div></div>
                    </div>
                </div>

                {/* Here we show label if labelShow is true */}
                {labelShow && (
                    <div className="loader-label">
                        {label}
                    </div>
                )}
            </div>
        </div>
    );
}

export default Loading;
